// Much of this was taken and refactored from react-add-to-calendar
// https://github.com/jasonsalzman/react-add-to-calendar
// https://github.com/jasonsalzman/react-add-to-calendar/blob/master/src/helpers/index.js
// https://github.com/jasonsalzman/react-add-to-calendar/blob/master/src/ReactAddToCalendar.js

import { oneLineTrim } from 'common-tags';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

import { Phrase } from 'components/Phrase';
import {
  CalendarService,
  DateTimeFormat,
  ICalendarEvent,
  ICalendarEventDownloadButtonProps,
  IState,
  Mode,
} from 'typings';

import { Button } from './styles';

const formatTime = (date: string) =>
  moment.utc(date).format(DateTimeFormat.DATETIME_VCAL);

const downloadEvent = (
  event: ICalendarEvent,
  calendarService: CalendarService,
  mode: Mode,
) => {
  if (mode === Mode.APP) {
    // Calendar.js *must* be included here, and only when in APP mode because it relies on the `cordova` global
    // being present, which does not happen until *after* app initialization and only happens in APP mode when the
    // cordova script is dynamically added to the page.
    require('cordova-plugin-calendar/www/Calendar.js');
    (window as any).plugins.calendar.createEventInteractively(
      event.title,
      event.location,
      event.description,
      new Date(event.startTime),
      new Date(event.endTime),
    );
  } else {
    let url = '';

    switch (calendarService) {
      case CalendarService.GOOGLE:
        url = oneLineTrim`
          https://calendar.google.com/calendar/render?action=TEMPLATE
          &dates=${formatTime(event.startTime)}/${formatTime(event.endTime)}
          &location=${encodeURIComponent(event.location)}
          &text=${encodeURIComponent(event.title)}
          &details=${encodeURIComponent(event.description)}
        `;
        window.open(url, '_blank');

        break;
      default:
        url = `${process.env.REACT_APP_ICS_URI}/${event.appointmentId}/${event.fileName}.ics`;
        window.open(url, '_top');

        break;
    }
  }
};

export const CalendarEventDownloadButton = ({
  calendarService,
  event,
}: ICalendarEventDownloadButtonProps) => {
  const { mode } = useSelector((state: IState) => ({
    mode: state.client.mode,
  }));

  return (
    <Button onClick={downloadEvent.bind(null, event, calendarService, mode)}>
      <Phrase id={`CALENDAR_EVENT_DOWNLOAD_BUTTON.${calendarService}`} />
    </Button>
  );
};
